import React, { useMemo, useState } from "react";

import { OpenInNew } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { isDev } from "root/utils/tech";

import Tooltip_ from "root/components/Tooltip";

import CerebroDrawer from "./Drawer";
import icon from "./elements.svg";

// ---------------------------------------------------------------------------------------------------------------------
export default function Cerebro({ isOn, toggleIsOn, disabled }) {
  //
  const [isOpen, setIsOpen] = useState(false);
  //
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px 18px",
          flexWrap: "wrap-reverse",
          justifyContent: "flex-end",
        }}>
        <Box
          sx={{ display: "flex", alignItems: "center", height: 32, gap: 0.75, cursor: "pointer" }}
          onClick={() => setIsOpen(true)}>
          <OpenInNew sx={{ fontSize: 20, color: "#CF3AA0" }} />
          <Typography sx={{ fontSize: 14, lineHeight: 1, color: "#CF3AA0" }}>
            Как работает «ЦЕРЕБРО»?
          </Typography>
        </Box>
        <Tooltip_
          title={disabled && "Режим «ЦЕРЕБРО» недоступен при высокой точности данных по остаткам"}>
          <Button
            sx={{
              height: 38,
              py: 0.5,
              px: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
              borderRadius: "8px",
              background: "#32383E",
            }}
            disabled={!isDev && disabled}
            variant={"contained"}
            onClick={toggleIsOn}>
            <Box
              sx={{
                height: 20,
                width: 40,
                borderRadius: 20,
                p: 0.75,
                background: isOn ? "#FBE3F3" : "white",
                display: "flex",
                alignItems: "center",
                justifyContent: isOn ? "flex-end" : "flex-start",
                transitionDuration: "0.5s",
              }}>
              <Box sx={{ height: 12, width: 12, borderRadius: "6px", background: "#7B125A" }}></Box>
            </Box>
            <Typography
              sx={{ textTransform: "none", fontSize: 18, lineHeight: 1.66, fontWeight: 500 }}>
              Режим <Typography sx={{ fontWeight: 700, display: "inline" }}>«ЦЕРЕБРО»</Typography>
            </Typography>
            <img src={icon} alt={"icon"} />
          </Button>
        </Tooltip_>
      </Box>
      {isOpen && <CerebroDrawer isOpen onClose={() => setIsOpen(false)} />}
    </>
  );
}
